import ArrowLeft from 'assets/images/sidebar/left.svg'
import { useDispatch } from 'react-redux'
import {
    toggleLogoutModal,
    toggleSideBar,
    toggleSupportModal,
} from 'store/redux/sidebar'
import { sideBarItems } from '../utilities'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useAuth } from 'context/authContext'
import useSetShare from 'utilities/hooks/share/useSetShare'

export default function SideBarItems() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { logout } = useAuth()
    const stringifyUser = localStorage.getItem('profile')
    const user: IAuthProfileData | null =
        stringifyUser && JSON.parse(stringifyUser)
    const { handleShareButton } = useSetShare()
    useEffect(() => {
        if (!user) {
            logout()
            navigate('/auth/login')
        }
    }, [user])
    return (
        <>
            <div className=" mx-4 w-[250px]">
                {user && (
                    <>
                        <div
                            className=" w-full flex justify-end"
                            onClick={() =>
                                dispatch(toggleSideBar({ isOpen: false }))
                            }
                        >
                            <img
                                src={ArrowLeft}
                                alt="arrow"
                                className=" cursor-pointer"
                            />
                        </div>
                        <div className=" mt-2 bg-header-bg p-4 rounded-lg text-center w-1/3">
                            <p className=" text-green-1 text-2xl">
                                {user.first_name[0]}
                            </p>
                        </div>
                        <p className=" mt-2 mb-1 text">
                            {user.first_name} {user.last_name}
                        </p>
                        <p className="">{`0${user.phone_number.slice(3)}`}</p>
                        <hr className=" w-full text-green-1 my-2 " />
                        {sideBarItems.map((item) => (
                            <div
                                className=" flex my-3 cursor-pointer"
                                onClick={() => {
                                    item.id === 13
                                        ? dispatch(
                                              toggleLogoutModal({
                                                  isOpenLogoutModal: true,
                                              })
                                          )
                                        : item.id === 5
                                        ? dispatch(
                                              toggleSupportModal({
                                                  isOpenSupportModal: true,
                                              })
                                          )
                                        : item.id === 14
                                        ? window.location.replace(
                                              'https://hamyanapp.com/about/'
                                          )
                                        : item.id === 10
                                        ? window.location.replace(
                                              'https://hamyanapp.com/blog/faq'
                                          )
                                        : item.id === 7
                                        ? window.location.replace(
                                              'https://hamyanapp.com/policy/'
                                          )
                                        : item.id === 8
                                        ? window.location.replace(
                                              'https://hamyanapp.com/how-to-use/'
                                          )
                                        : item.id === 9
                                        ? handleShareButton()
                                        : navigate(item.route)
                                }}
                                key={item.id}
                            >
                                <img
                                    src={item.icon}
                                    alt="sidebar-items"
                                    className=" mt-auto h-5 w-5 text-green-1"
                                />
                                <p className=" text-sm mr-2">{item.text}</p>
                            </div>
                        ))}
                        <p className=" text-center text-xs">نسخه : 1.0.12</p>
                    </>
                )}
            </div>
        </>
    )
}
